import React from 'react';
import { useTranslation } from 'react-i18next';
import StakingModalShell from '../StakingModalShell';

const StakeDetailsModal = ({ detail, onClose }) => {
  const { t } = useTranslation();
  if (!detail) return null;

  const { countdown } = detail;
  const hashFull = detail.txHashFull || String(detail.txHash || '').replace(/…/g, '').replace(/\u2026/g, '');
  const canUseExplorer =
    detail.explorerBaseUrl &&
    hashFull.length > 20 &&
    hashFull.startsWith('0x') &&
    !/^0x0+$/i.test(hashFull);
  const explorerUrl = canUseExplorer ? `${detail.explorerBaseUrl}/tx/${hashFull}` : null;

  const countdownLine = t('staking.countdown_line', {
    days: countdown?.days ?? 0,
    hours: countdown?.hours ?? 0,
    min: countdown?.minutes ?? 0,
    sec: String(countdown?.seconds ?? 0).padStart(2, '0'),
  });

  const titleNode = (
    <span className="staking-detail-pill">
      {t('staking.detail_pill_prefix', 'STAKE')} {detail.amount}
    </span>
  );

  return (
    <StakingModalShell title={titleNode} onClose={onClose}>
      <p className="staking-detail-status">
        <span className="staking-status-ok">✓</span>{' '}
        {t(`staking.stake_status_${detail.statusKey}`, detail.statusKey)}
      </p>
      <dl className="staking-detail-list">
        <div>
          <dt>{t('staking.stake_date', 'Stake date')}</dt>
          <dd>{detail.stakeDate}</dd>
        </div>
        <div>
          <dt>{t('staking.due_date', 'Due date')}</dt>
          <dd>{detail.dueDate}</dd>
        </div>
      </dl>
      <div className="staking-countdown">
        <p className="staking-countdown-label">
          {t('staking.staking_time', 'Staking time')}
        </p>
        <p className="staking-countdown-line">{countdownLine}</p>
        <div className="staking-countdown-grid" aria-hidden>
          <span>
            <strong>{countdown?.days ?? 0}</strong> {t('staking.cd_days', 'Days')}
          </span>
          <span>
            <strong>{countdown?.hours ?? 0}</strong> {t('staking.cd_hours', 'Hrs')}
          </span>
          <span>
            <strong>{countdown?.minutes ?? 0}</strong> {t('staking.cd_min', 'Min')}
          </span>
          <span>
            <strong>{String(countdown?.seconds ?? 0).padStart(2, '0')}</strong>{' '}
            {t('staking.cd_sec', 'Sec')}
          </span>
        </div>
      </div>
      <dl className="staking-detail-list">
        <div>
          <dt>{t('staking.tx_hash', 'Hash')}</dt>
          <dd className="staking-mono">{detail.txHash}</dd>
        </div>
        <div>
          <dt>{t('staking.confirmations', 'Confirmations')}</dt>
          <dd>{detail.confirmations}</dd>
        </div>
        <div>
          <dt>{t('staking.block', 'Block')}</dt>
          <dd>{detail.blockNumber}</dd>
        </div>
      </dl>
      {explorerUrl ? (
        <a
          href={explorerUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="staking-explorer-link"
        >
          {t('staking.see_polygonscan', 'See more on Polygonscan')}
          <span className="staking-ext-icon" aria-hidden>
            ↗
          </span>
        </a>
      ) : (
        <p className="staking-modal-note">
          {t('staking.explorer_placeholder', 'Explorer link when tx is available.')}
        </p>
      )}
    </StakingModalShell>
  );
};

export default StakeDetailsModal;
